import getCookies from "../Util/getCookies";

const safeParse = (data: any) => {
    try {
        return JSON.parse(data);
    } catch {
        return data || "";
    }
};

export const auditErrorRequest = (error: any) => {
    const { config, request, response } = error;
    const errData = response || request || config;
    const win: any = window

    const journeyName = getCookies("device-journeyName") || config?.headers?.['JourneyName'] || errData?.headers?.['JourneyName'];
    const deviceName = getCookies("device-poid") || config?.headers?.['POID'] || errData?.headers?.['POID'];
    const stepName = "deviceCart";
    const serviceName = config?.serviceName ? config?.serviceName : (config?.url ? getServiceName(config?.url) : 'deviceCart');
    const transactionId = response?.headers?.['X-Transaction-Id'] || config?.headers?.['X-Transaction-Id'] || "No Trans Id";
    const correlationId = errData?.headers?.['X-Correlation-Id'] || config?.headers?.['X-Correlation-Id'] || getCookies("device-xCoId");
    const shoppingCartId = getCookies("device-scId") || win?.shoppingCartId;
    const statusCode = errData?.status || response?.status || request?.status;
    const status = statusCode || "NETWORK_ERROR";
    const errorCode = statusCode || error?.message || "Unknown Error"
    const responseMsg = statusCode ? `Customer Connection Rest ${statusCode}` : "Customer Connection Rest";

    clearSessionStorage();
    setSessionStorage(transactionId, stepName, correlationId, journeyName, errorCode, deviceName);

    return {
        "ServiceName": serviceName,
        "JourneyName": journeyName,
        "EndpointURL": request?.responseURL || config?.url || "",
        "ShoppingCartId": shoppingCartId,
        "TransactionId": transactionId,
        "CorrelationId": correlationId,
        "SourceId": "PORTAL_CLIENT",
        "JsonRequest": safeParse(config?.data),
        "JsonResponse": response?.data ? safeParse(response.data) : request?.response ? safeParse(request.response) : responseMsg,
        "BackendRequestType": "",
        "BackendRequest": "",
        "BackendResponse": response?.data ? safeParse(response.data) : "",
        "RequestQueueName": "",
        "ResponseQueueName": "",
        "BackendURL": "",
        "Payload": {
            "header": [
                { Method: config?.method?.toUpperCase(), ...config?.headers, ...request?.headers, ...response?.headers }
            ]
        },
        "HTTPHeaders": {
            "header": [
                { "name": "X-Correlation-Id", "value": correlationId },
                { "name": "X-Source-Channel", "value": config?.headers?.["X-Source-Channel"] || "PORTAL" },
                { "name": "X-Transaction-Id", "value": transactionId }
            ]
        },
        "CreatedOn": config?.headers?.['X-Timestamp'] || new Date().toISOString(),
        "ProcessingTime": 0,
        "Status": status
    };
};

const getServiceName = (url: any) => {
    const parts = url.split('/');
    let serviceName = parts.pop();
    const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

    if (serviceName.includes('?')) serviceName = serviceName.split('?')[0];
    if (uuidRegex.test(serviceName)) serviceName = parts[parts?.length - 2];

    return serviceName;
};

const setSessionStorage = (transactionId: any, stepName: any, correlationId: any, journeyName: any, errorCode: any, deviceName: any) => {
    sessionStorage.setItem("xcoorelationid-error", correlationId);
    sessionStorage.setItem("transactionid-error", transactionId);
    sessionStorage.setItem("journeyname-error", journeyName);
    sessionStorage.setItem("stepname-error", stepName);
    sessionStorage.setItem("errorcode-error", errorCode);
    sessionStorage.setItem("DeviceName", deviceName);
};

const clearSessionStorage = () => {
    sessionStorage.removeItem("xcoorelationid-error");
    sessionStorage.removeItem("transactionid-error");
    sessionStorage.removeItem("journeyname-error");
    sessionStorage.removeItem("stepname-error");
    sessionStorage.removeItem("errorcode-error");
    sessionStorage.removeItem("DeviceName");
}


